/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { colors } from '@blend/consumer-components';

export namespace AgentCardCredentialWrapper {
  export interface Props extends React.HTMLAttributes<HTMLSpanElement> {}
}

const styles = StyleSheet.create({
  agentCardCredentialWrapper: {
    color: colors.clayPlus3,
  },
});

export const AgentCardCredentialWrapper: React.FC<AgentCardCredentialWrapper.Props> = ({ children, ...htmlProps }) => {
  return (
    <span className={css(styles.agentCardCredentialWrapper)} {...htmlProps}>
      {children}
    </span>
  );
};
